module.exports = __webpack_public_path__ + "static/media/Third-FlagDistortSmall.eeb8a068.gif";